import _Object$assign from 'babel-runtime/core-js/object/assign';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
export default {
  props: {
    eventItem: Object,
    type: String,
    popDisabled: {
      type: Boolean,
      default: false
    },
    imageStyle: Object
  },
  computed: _extends({}, mapState({
    qc: function qc(state) {
      return state.workspace.game.data;
    }
  }), {
    computedImageStyle: function computedImageStyle() {
      var style = {
        height: this.isFixedHeight ? '180px' : 'unset'
      };
      return _Object$assign(style, this.imageStyle);
    },
    targetLabel: function targetLabel() {
      return this.currentNode.name;
    },
    currentNode: function currentNode() {
      return this.qc.gameObj.nodePool.find(this.eventItem.node);
    },
    currentSrc: function currentSrc() {
      return this.currentNode.texture && this.currentNode.texture.atlas.img.currentSrc;
    },
    isFixedHeight: function isFixedHeight() {
      return this.currentNode.scripts.some(function (item) {
        return item.class === 'ps.MovieClip';
      });
    }
  })
};